var Help = {
	scrollInit:false,

	init: function() {
		AppEvent.on(player, "afterLoad", Help.afterLoad);

		Help.node = $("<div id='help'></div>");
		
		var langs;
		var project_name;
		var pano_name;

		try {
			langs = JSON.parse(PROJECT.settings['core/project_name']);
			project_name = langs[PROJECT.lang];
		} catch (e) {
			project_name = "";
		}
		//var project_name = "";

		var qrl = PROJECT.domain + ".wkraj.pl/html5//index.php?id=" + player.ident;

		var qrcode = "https://www.wkraj.pl/qrcode.php?q=high&domain=" + PROJECT.domain;

		if (player.offline)
			qrcode = "data/qrcode.png";

		Help.node.append(TPL.render("help-main", {"project_name" : project_name, "domain":PROJECT.domain, "ident": player.ident, 'qrcode': qrcode}));
		$("#panels").append(Help.node);

		Help.button = $("<div id='help_icon' class='bottombar circlebutton'><img src='assets/help_icon.png' width='32' height='32'></div><span id='help_tip' class='bottombar bbar_label'>" + TPL.lng("help.icon_title", "POMOC") + "</span>");
		$("#overlay").append(Help.button);

		Help.button.on(Events.pointer.down, function(e) {
			Help.open();
		});

		Help.node.find(".backarrow").on(Events.pointer.up, function(e) {
			Help.close();
		});

		SpeechManager.prepareTip("PLAYER.HELP_BUTTON", "TIPS");
	},

	afterLoad: function(data) {
		var qrl = "https://www.wkraj.pl/qrcode.php?q=high&domain=" + PROJECT.domain + ".wkraj.pl/html5/index.php?id=" + player.ident;

		if (player.current.place_name != "") {
			$("#pano_name").html(player.current.place_name);
		} else {
			$("#pano_name").html("Panorama nr. " + player.current.place_id);
		}

		//Help.node.html("");
		//Help.node.append(TPL.render("help-main", {"project_name" : project_name, "domain":qrl, "ident": player.ident}));
		if (!player.offline)
			$("#qrcode").attr("src", qrl);
		
		$("#help_pano_id").html(player.ident);
		$("#selfurl").attr("href", "https://" + PROJECT.domain + ".wkraj.pl/html5/index.php?id=" + player.ident);
	},

	close: function() {
		$("#help").hide();
		Tab.cancelStackRemove("help-sidebar");
	},

	open: function() {
		SpeechManager.speakTip("PLAYER.HELP_BUTTON", "TIPS");

		$("#help").show();
		$(".helpstate").show();
		$(".aboutstate").hide();
		ScrollBar.update("#help .helppage");

		Tab.cancelStackAdd("help-sidebar", Help.close);
	},

	about: function() {
		SpeechManager.speakTip("PLAYER.HELP_BUTTON", "TIPS");

		$("#help").show();
		$(".helpstate").hide();
		$(".aboutstate").show();
		ScrollBar.update("#help .helppage");
	}
}

PluginManager.add(Help);